import classNames from "classnames";

export type BlockForFullStory = {
    blockForFullStory?: boolean;
};

export const blockForFullStory = (className: string, props: BlockForFullStory) =>
    classNames(className, props.blockForFullStory && "fs-block");
